<i matTooltip="Expand" (click)="openDialog('0', '0')" class="fa-sharp fa-up-right-and-down-left-from-center mg-l-s expand-icon"></i>
